import { Div, DivProps } from '@kizi/core-components';
import { Steps, StepsItem, StepsProps } from '@kizi/shared-components';
import { Help, HelpProps } from '@kizi/comparator-components';
import React, { useContext } from 'react';
import { IWizardContext, WizardContext } from '@kizi/comparator-core';
const Flex = (props) => <Div {...props} display="flex" />;

interface HeaderProps extends DivProps {
  steps?: StepsProps['steps'];
  activeStep: number;
  helpContent: HelpProps;
}

export const Header: React.FC<HeaderProps> = ({
  steps = [],
  activeStep,
  helpContent,
  ...divProps
}) => {
  const { wizardService } = useContext<IWizardContext>(WizardContext);
  if (!wizardService) return null;

  const wrappedSteps: StepsItem[] = steps.map((step, i) => ({
    ...step,
    onStepClick: step.disabled
      ? undefined
      : () => wizardService.send({ type: 'GOTO', index: i + 1 }),
  }));

  return (
    <Div bg="white" py={4} px={3} {...divProps}>
      <Flex
        style={{
          maxWidth: '1180px',
          width: '100%',
          margin: 'auto',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Flex flexGrow={1} />
        <Flex flexGrow={1} justifyContent="center">
          <Steps activeStep={activeStep} steps={wrappedSteps} />
        </Flex>
        <Flex flexGrow={1} justifyContent="flex-end">
          <Help {...helpContent} />
        </Flex>
      </Flex>
    </Div>
  );
};

export default Header;
